import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const regions:SchemaTableOptions = {
    name:<string> 'regions',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'code', value: 'VARCHAR(255) NOT NULL'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
    ]
}